$( document ).ready(function() {
    // SITE SCROLLER
  $(window).scroll(function() {
    if($(window).scrollTop()>200){
      $("#site-scroll").fadeIn();
    } else {
      $("#site-scroll").fadeOut();
    }
  });
  $(document).on('click', '#site-scroll', function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });
  if(window.appbrew){
  $(".header-site-wrapper").hide();
  $(".appBr_head_rem").hide();
}
 $(document).on('click', '#gift-wrap-checkbox', function () {
    if (!$(this).is(':checked')) {
        $(".hid-box-checkbox").show();
    } else {
        $(".hid-box-checkbox").hide();
    }
});
 $(document).on('click', '#gift-box-checkbox', function () {
 if (!$(this).is(':checked')) {
        $(".hid-wrap-checkbox").show();
    } else {
       $(".hid-wrap-checkbox").hide();
    }
  });
// Relove and Suta Product Add to Cart Condition
function check_items(event) {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function (cart) {
            var items = cart['items'];
             var  totalQuantity = 0;
           console.log('Cart Items:', items);
            for (let i = 0; i < items.length; i++) {
                var productType = items[i]['product_type'];
                var productVendor = items[i]['vendor'];
                 var qty = items[i]['quantity'];
                 totalQuantity += qty;
                if (productVendor === 'Relove') { 
                    $("buy-buttons.buy-buttons").addClass("not-rel");
                    $(".hid-wrap-checkbox").hide();
                    $(".hid-box-checkbox").hide();
                  var intervalId = setInterval(function() {
              $(".cbb-frequently-bought-recommendations-container .cbb-frequently-bought-add-button").attr("disabled", true);
                }, 2000);
                 setTimeout(function() {
      clearInterval(intervalId);
      console.log("Interval cleared after 5 seconds.");
    }, 5000);
                              return;
                }
             else { 
                    $(".relove-button-add-to-cart").addClass("not-suta");
                   return;
                }
            }
          if (totalQuantity == 0) {
                    $(".cbb-frequently-bought-recommendations-container .cbb-frequently-bought-add-button").attr("disabled", false);
                 $("buy-buttons.buy-buttons").removeClass("not-rel");
                  $(".relove-button-add-to-cart").removeClass("not-suta");
              }
        }
    });
}
check_items(event);
$(document).on('click', 'line-item-quantity', function (event) {
setTimeout(function() {
    check_items(event); 
}, 1000); 
});
$(document).on('click', '.relove-button-add-to-cart.not-suta', function (event) {
event.preventDefault();
$("#relove-msg").css("display", "block");
$("html").addClass("lock");
 check_items(event);
});
$(document).on('click', 'buy-buttons.not-rel', function (event) {
event.preventDefault();
$("#suta-msg").css("display", "block");
$("html").addClass("lock");
 check_items(event);
});
$(document).on('click', '#sutaclose-btn, .over-lay-suta', function () {
$("#suta-msg").css("display", "none");
$("#relove-msg").css("display", "none");
$("html").removeClass("lock");
});
// Relove and Suta Product Add to Cart Condition
// Size Chart Toggle in inches and cms
$(".toggle-tab-inches-cm").click(function(){
    var tabId = $(this).data("tab");
    $(".toggle-tab-inches-cm").removeClass("active");
    $(this).addClass("active");
    $(".tab-content-inches-cm").hide();
    $("#" + tabId).show();
  });
// Size Chart Toggle in inches and cms
//Custom Reviews Positioning
 $(document).on('click', '.product-gallery__media', function () {
     $('.product-gallery__zoom-button').click();
 });
var htmlContentrating = $('#shopify-block-loox-rating').html();
$('.new_rating_position').html(htmlContentrating);
$(document).on('click', '.cust_reviews_click', function () {
var htmlContentcustreviews = $('#looxReviews').html();
$('.customer_revies_custom_dropDown').html(htmlContentcustreviews);
});
 $(document).on('click', '.new_rating_position', function () {
     var offset = 70;
     var targetPosition = $(".product-info__block-item .cust_reviews_click").offset().top - offset;
        $("html, body").animate({ scrollTop: targetPosition }, 1000);
    $('.cust_reviews_click').attr({
    "aria-expanded": "true",
    "open": "true"
});
var htmlContentcustreviews = $('#looxReviews').html();
$('.customer_revies_custom_dropDown').html(htmlContentcustreviews);
  });
//Custom Reviews Positioning
//Add to Cart Feature
$(document).on('click', '.optionSelectsize', function (event) {
    $(".selct_size_btn").hide();
    $(".sizeSelectorBTN").addClass("remove_sizeSelectorBTN");
    $("buy-buttons.buy-buttons").removeClass("sizeSelectorAddToCart");
     $(".size-selectorPopup_Button").addClass("done_AddToCart");
});
$(document).on('click', '.sizeSelectorBTN', function (event) {
     $(".selct_size_btn").show();
     $(".product-info__block-item[data-block-type='variant-picker']").addClass("animation_size");
      var windowWidth = $(window).width();
     if(windowWidth <= 768) {
     var getAllsizeOption= $(".product-info__block-item[data-block-type='variant-picker']").html();
     $(".size-selectorPopup_value").html(getAllsizeOption);
     $(".size-selectorPopup").addClass("active_size-selectorPopup");
    $(".product-info__block-item[data-block-type='buy-buttons'] .buy-buttons").addClass("wid-fl");
   $(".product-info__block-item[data-block-type='buy-buttons'] .swym-wishlist-button-bar").addClass("hide-on-cl");
    $(".sizeSelectorBTN").addClass("wid-fl");
     }
});
$(document).on('click', 'buy-buttons.buy-buttons', function (event) {
    $(".product-info__block-item[data-block-type='buy-buttons'] .buy-buttons").removeClass("wid-fl");
   $(".product-info__block-item[data-block-type='buy-buttons'] .swym-wishlist-button-bar").removeClass("hide-on-cl");
     $(".size-selectorPopup").removeClass("active_size-selectorPopup");
    $(".size-selectorPopup_value").empty(); 
});
$(document).on('click scroll', function(event) {
    // Check if the click event originated from within the pop-up or its descendants
    var newR = $(".product-info__block-item");
    if (!$(event.target).closest(newR).length) {
        $(".product-info__block-item[data-block-type='buy-buttons'] .buy-buttons").removeClass("wid-fl");
        $(".product-info__block-item[data-block-type='buy-buttons'] .swym-wishlist-button-bar").removeClass("hide-on-cl");
        $(".size-selectorPopup").removeClass("active_size-selectorPopup");
        $(".sizeSelectorBTN").removeClass("wid-fl");
        $(".size-selectorPopup_value").empty(); 
    }
});
$(document).on('click', '.size-selectorPopup_value label.optionSelectsize', function (event) {
   $(".size-selectorPopup_value label.optionSelectsize").removeClass("active");
   $(this).addClass("active");
   });
//Add to Cart Feature
});
